import { render, staticRenderFns } from "./OverviewSublet.vue?vue&type=template&id=388628f0"
import script from "./OverviewSublet.vue?vue&type=script&lang=js"
export * from "./OverviewSublet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388628f0')) {
      api.createRecord('388628f0', component.options)
    } else {
      api.reload('388628f0', component.options)
    }
    module.hot.accept("./OverviewSublet.vue?vue&type=template&id=388628f0", function () {
      api.rerender('388628f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewSublet.vue"
export default component.exports